import React, { useEffect, useState } from "react";
import { validate, validateEmail, validatePassword, validatePhone } from "../../../../utils";
import { Checkbox } from "@mui/material";

function Input(props) {
  const {
    img,
    label,
    name,
    handleChange,
    value,
    submit,
    required,
    validation,
    disabled,
    show
  } = props;

  const [error, setError] = useState(false);

  const onChange = (event) => {
    let { name, value, checked } = event.target;
   
    // For checkbox, pass the checked value instead of the string value
    handleChange({ target: { name, value: name === "headquarters" ? checked : value } });
  };

  useEffect(() => {
    if (submit) {
      if (validation === "email") {
        setError(!validateEmail(value, required));
      } else if (validation === "phone") {
        setError(!validatePhone(value, required));
      } else if (validation === "password") {
        setError(!validatePassword(value));
      } else if (validation === "required") {
        setError(typeof value === "string" && value.trim().length === 0);
      }
    }
  }, [submit, value, required, validation]);

  return (
    <>
      <div>
        <span className="det-label">
          {img !== "" ? (
            <img
              src={require(`../../../../assets/DigitalMarketing/image/customer/${img}.png`)}
              alt="icon"
            />
          ) : (
            ""
          )}
          {label}
        </span>
        {name === "description" && show ? (
          <textarea
            rows={20}
            cols={10}
            placeholder="Empty"
            style={{ border: error && submit ? "1px solid red" : "" }}
            className="textarea-custom"
            value={value}
            name={name}
            onChange={onChange}
          />
        ) : name === "medicineDose" ? (
          <input
            type="text"
            placeholder="Empty"
            disabled={disabled}
            onKeyPress={(e) => {
              const charCode = e.which ? e.which : e.keyCode;
              if (
                !(
                  (charCode >= 65 && charCode <= 90) || // Uppercase letters
                  (charCode >= 97 && charCode <= 122) || // Lowercase letters
                  (charCode >= 48 && charCode <= 57) || // Numbers
                  charCode === 32 ||
                  charCode === 46 // Space
                )
              ) {
                e.preventDefault();
              }
            }}
            style={{ border: error && submit ? "1px solid red" : "" }}
            className="text-custom"
            value={value}
            name={name}
            onChange={onChange}
          />
        ) : name === "headquarters" ? (
          <Checkbox
            checked={value} // Pass the current state to the checkbox
            onChange={onChange}
            sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
          />
        ) : (
          <input
            type="text"
            placeholder="Empty"
            style={{ border: error && submit ? "1px solid red" : "" }}
            className="text-custom"
            value={value}
            name={name}
            onChange={onChange}
            disabled={disabled}
          />
        )}
      </div>
      {error && validation === "password" && (
        <p
          style={{
            textAlign: "end",
            marginBottom: "0",
            fontSize: "12px",
            color: "red",
          }}
        >
          minimum 8 characters Required
        </p>
      )}
    </>
  );
}

export default React.memo(Input);
